import type { BiomeId, ItemType, RegionItem } from './types';
import { ITEMS_PER_REGION_MAX, ITEMS_PER_REGION_MIN } from './types';
import { placeInRegion } from './placement';
import { regionRegistry } from './region-registry';
import { mulberry32, hashCode } from './rng';

/** Tipos válidos por bioma (BR-U4-06). */
const TYPES_PER_BIOME: Record<BiomeId, ItemType[]> = {
  meadow: ['berry', 'flower'],
  forest: ['berry', 'flower', 'crystal'],
  cave: ['crystal', 'shell'],
  coast: ['shell', 'flower'],
};

/** Spawn determinístico de items para um bioma+dia. */
export function spawnRegionItems(biome: BiomeId, dayCount: number): RegionItem[] {
  const seed = hashCode(`${biome}-${dayCount}`);
  const rng = mulberry32(seed);
  const range = ITEMS_PER_REGION_MAX - ITEMS_PER_REGION_MIN + 1;
  const count = ITEMS_PER_REGION_MIN + Math.floor(rng() * range);

  const types = TYPES_PER_BIOME[biome];
  const region = regionRegistry.get(biome);
  if (!region) return [];
  const items: RegionItem[] = [];

  for (let i = 0; i < count; i++) {
    const type = types[Math.floor(rng() * types.length)]!;
    const placement = placeInRegion({
      region,
      seed: `${biome}:${dayCount}:resource:${i}`,
      zoneKinds: ['resource'],
      radius: 16,
      occupied: items,
      minSeparation: 32,
      avoidEntrancesBy: 48,
    });
    if (!placement.ok) continue;
    items.push({
      id: `${biome}-${dayCount}-${i}`,
      type,
      x: placement.point.x,
      y: placement.point.y,
      collected: false,
    });
  }
  return items;
}
